var map = {
	"./accessibility.svg": "a483",
	"./arrow-left.svg": "06a1",
	"./book.svg": "03bb",
	"./contents.svg": "645a",
	"./earth.svg": "9c23",
	"./exit.svg": "c7e1",
	"./exit_1.svg": "c304",
	"./exit_10.svg": "ef2b",
	"./exit_11.svg": "dc97",
	"./exit_12.svg": "049f",
	"./exit_13.svg": "3338",
	"./exit_14.svg": "39dd",
	"./exit_15.svg": "1668",
	"./exit_16.svg": "dac4",
	"./exit_17.svg": "d8c3",
	"./exit_18.svg": "63ec",
	"./exit_2.svg": "7a26",
	"./exit_3.svg": "225a",
	"./exit_4.svg": "6827",
	"./exit_5.svg": "f20f",
	"./exit_6.svg": "7320",
	"./exit_7.svg": "cc0c",
	"./exit_8.svg": "0ba2",
	"./exit_9.svg": "5bba",
	"./feedback.svg": "b845",
	"./feedback7.svg": "c2c3",
	"./feedback8.svg": "e007",
	"./fullscreen.svg": "68a5",
	"./help.svg": "1354",
	"./information.svg": "fc18",
	"./logout.svg": "9ab3",
	"./logout1.svg": "9942",
	"./page.svg": "4e75",
	"./pointer.svg": "142f",
	"./questionmark.svg": "0cd3",
	"./questionmark2.svg": "9462",
	"./settings.svg": "af90",
	"./sound.svg": "6c6b",
	"./user.svg": "61e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bc4";